<mat-icon class="close" (click)="close()">close</mat-icon>
<div class="container-fluid pt-2">
    <div class="Tabletitle">
        <span class="mt-5" style="font-size: 20px"> Files migrating to ECM </span>
    </div>
    <form #initiateForm="ngForm">
        <div>
            
            <table mat-table [dataSource]="docsList" matSort aria-describedby="capture-table">
                <!-- Checkbox Column -->          
                <ng-container matColumnDef="File Name">
                    <th id="file-name" mat-header-cell *matHeaderCellDef>File Name
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.fileName}}

                        <div class="progress">
                            <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                                attr.aria-valuenow="{{ element.value }}" aria-valuemin="0" aria-valuemax="100"
                                [ngStyle]="{ width: element.value + '%' }">
                                {{ element.value }}%
                            </div>
                        </div>
                        <!-- <div class="new" *ngIf="element.value === 100">
            File Upload Completed!
          </div> -->


                    </td>
                </ng-container>
                <ng-container matColumnDef="Size">
                    <th id="size" mat-header-cell *matHeaderCellDef>Size
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.size|filesize}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                </tr>
                <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

            </table>
        </div>
    </form>
     
</div>